<template>
  <div id="app">

    <mt-button  style="border:none;background-color:none;height:40px;width:74px;border-radius:30px;position:absolute;top:5px;left:15px;z-index:9999999;background-color:red;color:white;" plain type="default" @click="enterApp()" id="enter" v-if="guideShow">进入</mt-button>

    <Swiper v-if="guideShow" :autoPlay='false' style="">
      <Slide>
        <img :src="Addr.getCdnAddr()+'qiniu/guide/0.jpg'" alt="" class="guide-img">
      </Slide>
      <Slide>
        <img :src="Addr.getCdnAddr()+'qiniu/guide/1.png'" alt="" class="guide-img">
      </Slide>
      <Slide>
       		<img :src="Addr.getCdnAddr()+'qiniu/guide/2.png'" alt="" class="guide-img">
      </Slide>
      <Slide>
       		<img :src="Addr.getCdnAddr()+'qiniu/guide/3.png'" alt="" class="guide-img">
      </Slide>
      <Slide>
       		<img :src="Addr.getCdnAddr()+'qiniu/guide/4.png'" alt="" class="guide-img">
      </Slide>
    </Swiper>
  
    <!-- <mt-swipe id="guide" :auto="0" style="background-color:white;" v-if="guideShow">
      <mt-swipe-item>
        <img src="./assets/1.png" alt="" class="guide-img">
      </mt-swipe-item>
      <mt-swipe-item>
        <img src="./assets/2.png" alt="" class="guide-img">
      </mt-swipe-item>
      <mt-swipe-item>
        <img src="./assets/3.png" alt="" class="guide-img">
      </mt-swipe-item>
      <mt-swipe-item>
        <img src="./assets/4.png" alt="" class="guide-img">
        <mt-button  style="border:none;background-color:none;height:40px;width:74px;border-radius:30px;position:absolute;top:5px;left:15px;z-index:9999999;background-color:red;color:white;" plain type="default" @click="enterApp()" id="enter">进入</mt-button>
      </mt-swipe-item>
    </mt-swipe> -->

    <!-- <mt-header style="background-color:#E60202;position:fixed;left:0;top:0;z-index:99999;width:100%;height:33px;">
		  <router-link to="/person" slot="left">
		    <mt-button   @click="showPersonPage()"><i class="iconfont ren" style="height:15px;color:white;"></i></mt-button>
		  </router-link>
		</mt-header> -->

    <!-- <mt-tab-container v-model="selected" style="margin-top:33px;">
      <mt-tab-container-item id="index">
        <indexMapList></indexMapList>
      </mt-tab-container-item>
      <mt-tab-container-item id="list">
        <listModular></listModular>
      </mt-tab-container-item>
      <mt-tab-container-item id="course">
        <courseModular></courseModular>
      </mt-tab-container-item>
      <mt-tab-container-item id="my">
        <myModular></myModular>
      </mt-tab-container-item>
    </mt-tab-container> -->
    <!-- <div style="margin-top:33px;" v-if="guideShow==false"> -->
    <div class="margintop" v-if="guideShow==false">
      <router-view/>
    </div>
    

    <div class="learingFooter" v-if="guideShow==false">
      <mt-tabbar v-model="$store.state.mineStore.selected" :fixed="true">
        <mt-tab-item id="list">
          <!-- <i class="iconfont icon-More-normal"></i> -->
          <div style="font-weight:bold;font-size:1rem">寻习足迹</div>
        </mt-tab-item>

          <mt-tab-item id="party20">
           <!-- <i class="iconfont icon-dangzhengjiguanzhengtizhizhi-dangdejianshe-dangjianfengcai-liangxindangjian"></i> -->
          <div style="font-weight:bold;font-size:1rem">喜迎20大</div>
       
        </mt-tab-item>
     <!--这里修改的还要加回来，占时改成喜迎20大-->
        <!-- <mt-tab-item id="course">
          <i class="iconfont icon-youhuijuan-xianxing"></i>
          <div style="margin-top:4px;font-weight:bold;">图说四史</div>
        </mt-tab-item> -->

        <mt-tab-item id="index" >
          <div style="font-weight:bold;font-size:1rem">铸魂育人</div>
        </mt-tab-item>
        <!--这里修改的还要加回来，占时改成百年献礼-->
        
        <mt-tab-item id="my">
          <!-- <i class="iconfont icon-Username"></i> -->
          <div style="font-weight:bold;font-size:1rem">红医传承</div>
        </mt-tab-item>
         <!-- <mt-tab-item id="centennialpolicy">
          <i class="iconfont icon-3-bainianfuwuyouzhi-01"></i>
          <div style="margin-top:4px;font-weight:bold;">百年征程</div>
        </mt-tab-item> -->
      </mt-tabbar>
    </div>
    
  </div>
</template>

<script>
import ClassItem from "./components/class-Item.vue";
import listModular from "./module-list/index.vue";
import courseModular from "./module-course/index.vue";
import myModular from "./module-my/index.vue";

//新增20大和百年征程
// import myModular from "./module-party20/index.vue";
// import School100 from "./module-school100/index.vue";
import store from "@/store/index";

import Addr from "./utils/getAPI";
import axios from "axios";
import ilabX from "./utils/ilabX";

import { Toast, MessageBox } from "mint-ui";

import { Swiper, Slide } from "vue-swiper-component";
export default {
  name: "App",
  // beforeDestroy() {
  //   //https://blog.csdn.net/robin90814/article/details/90603369
  //   //newnewnew关闭前去掉在线人数问题
  //   window.removeEventListener("beforeunload", e =>
  //     this.beforeunloadHandler(e)
  //   );
  //   window.removeEventListener("unload", e => this.unloadHandler(e));
  // },
  data() {
    return {
      //wyk2021
      Addr:Addr,
      guideShow: true,
      guideImgs: [
        {
          url: require("./assets/1.png")
        },
        {
          url: require("./assets/2.png")
        },
        {
          url: require("./assets/3.png")
        },
        {
          url: require("./assets/4.png")
        }
      ],
      selected: this.$store.state.mineStore.selected
    };
  },
  created() {
    //判断是否是电脑端
    if (this.isDesktop() == true) {
      this.guideShow = false;
      localStorage.setItem("ifShowGuide", "off");
      return;
    }

    console.log("created");
    console.log(localStorage.getItem("ifShowGuide"));
    //判断引导页显示选项初始值
    //如果没有值，或是为true  显示
    if (
      localStorage.getItem("ifShowGuide") == null ||
      localStorage.getItem("ifShowGuide") == undefined
    ) {
      this.guideShow = true;
      //默认初始化后关闭引导页
      localStorage.setItem("ifShowGuide", "off");
      //默认不关闭 wyk2021
      // localStorage.setItem("ifShowGuide", "on");

    } else if (localStorage.getItem("ifShowGuide") == "on") {
      this.guideShow = true;
    } else if (localStorage.getItem("ifShowGuide") == "off") {
      //如果为false，不显示
      this.guideShow = false;
    }
  },
  methods: {
    isDesktop() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return false;
      } else {
        return true;
      }
    },
    beforeunloadHandler(e) {
      this._beforeUnload_time = new Date().getTime();
    },
    // weixinClose(e){
    //   this.removeOnlineNumber();
    // },
    unloadHandler(e) {
      // console.log("unloadHandler");
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      // debugger;
      //判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        // this.removeOnlineNumber();
      }
    },
    //更新浏览人数
    updateViewNumber(){
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "user/view"
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode != 100) {
            Toast({
                message: res.data.returnMsg,
                position: "bottom",
                duration: 800
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    setSize() {
      //0 APP
      // if(document.getElementsByClassName("wh_slide")){
      //   var slides=document.getElementsByClassName("wh_slide");
      //   console.log("slides is:");
      //   console.log(slides);
      //   for (var i = 0; i < slides.length; i++) {
      //     slides[i].style.height = window.innerHeight + "px";
      //     slides[i].style.width = window.innerWidth + "px";
      //   }
      // }
      if (document.getElementById("guide")) {
        //设置引导图高度
        document.getElementById("guide").style.height =
          window.innerHeight + "px";
        //设置引导图宽度
        document.getElementById("guide").style.width = window.innerWidth + "px";
      }

      if (document.getElementsByClassName("guide-img")) {
        //设置引导图片高度
        var items = document.getElementsByClassName("guide-img");
        // console.log("guide item is:");
        // console.log(items);
        for (var i = 0; i < items.length; i++) {
          items[i].style.height = window.innerHeight + "px";
          items[i].style.width = window.innerWidth + "px";
        }
      }

      if (document.getElementById("enter")) {
        //设置地图高度
        document.getElementById("enter").style.top =
          window.innerHeight - 120 + "px";
        //设置地图宽度
        document.getElementById("enter").style.left =
          window.innerWidth / 2 - 37 + "px";
      }
    },
    enterApp() {
      this.guideShow = false;
    },
    showPersonPage() {
      console.log("ss");
      //this.selected="";
    },
    init: function() {
      //let sel = this.$route.path;
      // if (sel.slice(1)) {
      //   this.selected = sel.slice(1);
      // }
    }
  },
  computed: {
    listenSelected() {
      return this.$store.state.mineStore.selected;
    }
  },
  watch: {
    listenSelected: function(val, oldVal) {
      console.log("store selected watching");
      //  if (val == "index" || val == "list" || val == "course" || val == "my") {
      //   this.$router.push(val);
      // }
      if (val == "index" || val == "list" || val == "course" || val == "my"||"party20"||"centennialpolicy") {
        this.$router.push(val);
        
      }
    }
    //   selected(val, oldVal) {
    //     this.$router.push(val);
    //   }
  },
  mounted: function() {
    //https://blog.csdn.net/robin90814/article/details/90603369
    //newnewnew关闭前去掉在线人数问题
    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e));
    window.addEventListener("unload", e => this.unloadHandler(e));

    window.addEventListener("resize", () => {
      console.log("resize");
      this.setSize();
    });

    this.setSize();

    this.init();

    //更新浏览人数
    this.updateViewNumber();

    //超过登录时间默认不登录
    if(Date.parse(new Date())-this.$store.state.mineStore.loginTime>1000*3600*1){
      this.$store.commit("updateUserId", "");
      this.$store.commit("updateUserNumber", "");
      this.$store.commit("updateUserName", "");
      this.$store.commit("updateRole", "");
      this.$store.commit("updateIsLogin", false);
      this.$store.commit("updateLoginTime", "");
    }
    
  },
  components: {
    ClassItem,
    listModular,
    courseModular,
    myModular,
    // School100,
    Swiper,
    Slide
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* max-width: 640px; */
  width: 100%;
}
.mint-tabbar > .mint-tab-item {
  color: rgb(68, 85, 102);
}
.mint-tabbar > .mint-tab-item.is-selected {
  background-color: #eaeaea;
  color: #e60202!important;
}
.margintop{
  margin-top:33px;
}
/* .guide-img {
  height: 500px;
  width: 500px;
} */
</style>




// WEBPACK FOOTER //
// src/App.vue